<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="width:340px;" />
						<col style="width:130px;" />
						<col style="width:300px;" />
						<col style="width:120px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>PO No</th>
							<td>
								<input type="text" v-model.trim="purchase.po_dn" class="tbl_int ssm2_int" readonly disabled />
								<span style="margin-left:10px;">{{ purchase.po_type == 'B' ? 'Back Order' : 'New Order' }}</span>
								<!-- <select class="tbl_select" style="width:95px;" v-model="purchase.po_type" disabled>
									<option value="N">New Order</option>
									<option value="B">Back Order</option>
								</select> -->
								<template v-if="purchase.closed_yn == 'Y'"> (Closed)</template>
							</td>
							<th>Vendor</th>
							<td colspan="3">
								<div style="float:left;"><PartnerSelect v-model="purchase.vendor_code" :initialName="purchase.vendor_name" ph="Vendor" :showName="true" :vendorOnly="true" :typeahead="user.company_id == 'jc'" @set-partner="setVendor" /></div>
							</td>
						</tr>
						<tr>
							<th>PO Date</th>
							<td>
								<CustomDatePicker v-model="purchase.po_date" />
								<span style="margin-left:20px;color:blue;font-weight:bold;" v-if="item_sum.total_shipped_quantity > 0"> {{ item_sum.total_shipped_quantity == item_sum.total_quantity ? 'All' : 'Partially' }} Shipped </span>
							</td>
							<th>Est. Ship Date</th>
							<td><CustomDatePicker v-model="purchase.estimated_ship_date" /> <a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="applyEsdToItems(true)">Apply to Item(s)</a></td>
							<th>ETA Date</th>
							<td><CustomDatePicker v-model="purchase.eta_date" /> <a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="applyEtaDateToItems(true)">Apply to Item(s)</a></td>
						</tr>
						<tr>
							<th>Payment Term</th>
							<td><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="purchase.payment_term_code" /></td>
							<th>Trade Term</th>
							<td><CodeSelect className="tbl_select" :codes="tradeTerms" v-model="purchase.trade_term_code" /></td>
							<th>Location</th>
							<td><CodeSelect class-name="tbl_select" :codes="locationTypes" v-model="purchase.location_code" /></td>
						</tr>
						<tr>
							<th>Delivery Type</th>
							<td><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="purchase.po_delivery_type_code" /></td>
							<th>Payment Type</th>
							<td><CodeSelect className="tbl_select" :codes="paymentTypes" v-model="purchase.payment_type_code" /></td>
							<template v-if="user.company_id == 'jc'">
								<th>Purchaser</th>
								<td>
									<select v-model="purchase.purchaser_id" class="tbl_select lm_int">
										<option :value="null"></option>
										<option v-for="pu in users" v-bind:value="pu.user_id" v-bind:key="pu.user_id">{{ pu.name }}</option>
									</select>
								</td>
							</template>
						</tr>
						<tr>
							<th>Hold Type</th>
							<td><CodeSelect className="tbl_select" :codes="holdTypes" v-model="purchase.po_hold_type_code" /></td>
							<!-- <th>Qty/Amt.(Shipped)</th> -->
							<th>Item Qty / Amt</th>
							<td>
								<currency-input type="text" v-model="purchase.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-model="item_sum.total_amount" class="tbl_int ssm_int al_right" readonly />
							</td>

							<th>DC / Total Amount</th>
							<td>
								<currency-input type="text" v-model="purchase.discount_amount" class="tbl_int ssm_int al_right" />
								<currency-input type="text" v-model="purchase.total_amount" class="tbl_int ssm_int al_right" style="font-weight:bold;" readonly />
								<label for="closed_yn" style="margin-left:15px;"> <input type="checkbox" id="closed_yn" v-model="purchase.closed_yn" true-value="Y" false-value="N" />Closed</label>
							</td>
						</tr>
						<tr>
							<th>Description</th>
							<td colspan="3"><input type="text" v-model.trim="purchase.description" class="tbl_int" /></td>
							<th>Remark</th>
							<td><input type="text" v-model.trim="purchase.remark" class="tbl_int" /></td>
						</tr>
						<tr v-if="user.admin_yn == 'Y'">
							<td colspan="6">Created : {{ purchase.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ purchase.crt_user }}, Last updated : {{ purchase.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ purchase.upd_user }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- New Item -->
			<div class="left_option">
				<!-- <em style="padding-left:20px;padding-right:10px;"><b>Search Item(s) : </b></em> -->
				<em v-if="false" class="lt_text">Item {{ headers.class }}</em>
				<span v-if="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" @set-item-class="setItemClass" /> </span>

				<span class="int_type half_int">
					<!-- <input type="text" v-model.trim="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" /> -->
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" placeholder="Item / Class Name or Code"> </autocomplete>
				</span>

				<a href="javascript:;" class="search_bt mgr_15" @click="search()">Search and Add Item(s)</a>
				<input type="file" v-if="this.purchase.vendor_code" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :disabled="!this.purchase.vendor_code || excel_loading" @change="readFile" />
				<span v-if="excel_loading" style="color:blue;font-weight:bold;">Reading Excel...</span>
				<span v-if="this.purchase.vendor_code && user.company_id == 'jc'">* Excel Format : Item Code(or Barcode), Quantity / 1st row = header</span>
				<span v-else-if="this.purchase.vendor_code">* Excel Format : {{ headers.class }}, Color, Quantity</span>
				<!-- <a href="javascript:;" class="gray_bt" @click="reset()">Reset</a> -->
			</div>

			<table class="list_tbl mgb_0 add_top_line" ref="purchase_items" border="0">
				<thead>
					<tr>
						<th width="30px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
						<th width="150px;">{{ headers.class }}</th>
						<th width="150px;" v-if="profile.show_item_code == 'Y'">Item Code</th>
						<th>Name</th>
						<th v-if="user.company_id != 'jc'" width="140px;">Color</th>
						<th style="width: 3%;" v-if="user.company_id == 'he'">Rack</th>
						<th style="width: 5%;" v-if="factory_code_show">Factory Code</th>
						<th width="5%">Qty</th>
						<th width="3%" v-if="user.company_id == 'jc'">U/M</th>
						<th width="3%" v-if="user.company_id == 'jc'">S.U/M</th>
						<th width="5%" v-if="user.company_id == 'jc'">Pack Unit</th>
						<th width="5%">Cost / Price</th>
						<th width="5%" v-if="user.company_id == 'jc'">P.cost</th>
						<th width="5%">Amount</th>
						<th width="5%">{{ user.company_id == 'jc' ? 'STD cost' : 'FOB Cost' }}</th>
						<th width="5%" v-if="user.company_id != 'jc'">FOB Amount</th>
						<th width="3%">{{ user.company_id == 'jc' ? 'QTY/CTN' : 'Pack' }}</th>
						<th width="4%" v-if="user.company_id == 'jc'">On Hand</th>
						<th width="6%">ESD</th>
						<th width="6%">ETA Date</th>
						<th width="5%">Shipped Qty</th>
						<th width="5%">Remain Qty</th>
						<th width="5%">Remain Amt.</th>
						<th width="4%" v-if="user.company_id == 'jc'">History</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in items" v-bind:key="item.po_item_no">
						<!-- <td class="al_center"><input type="checkbox" v-model="item.selected" :disabled="item.shipped_quantity > 0" /></td> -->
						<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
						<td class="al_left">
							<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
								{{ item.class_code }}<span v-if="item.class_so_blocked">&nbsp;<font color="red">Blocked</font></span>
							</template>
						</td>

						<td class="al_left" v-if="profile.show_item_code == 'Y'">{{ item.item_code }}</td>

						<td class="al_left">
							<a href="javascript:;" @click="selectItem(item)">{{ item.item_name }}</a>
						</td>
						<td v-if="user.company_id != 'jc'" class="al_left">{{ item.color_code }}</td>
						<td v-if="user.company_id == 'he'">
							{{ item.rack }}
						</td>
						<td v-if="factory_code_show">
							{{ item.im_factory_code }}
						</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model.trim="item.quantity"
								:precision="0"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="quantity"
								@keydown.down.prevent="goTo('quantity', index + 1)"
								@keydown.up.prevent="goTo('quantity', index - 1)"
								@keydown.right.prevent="goTo('unit_price', index)"
								@keydown.left.prevent="goTo('unit_price', index - 1)"
								:style="user.company_id != 'jc' && item.packing > 0 && item.quantity % item.packing != 0 ? 'color:red;' : 'color:black;'"
							/>
						</td>
						<td v-if="user.company_id == 'jc'" class="al_center">{{ item.purchase_unit_code }}</td>
						<td v-if="user.company_id == 'jc'" class="al_center">{{ item.unit_code }}</td>
						<td v-if="user.company_id == 'jc'" class="al_center">{{ item.packing_unit }}</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model="item.unit_price"
								:precision="profile.po_decimal_point"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="unit_price"
								:style="item.im_cost != item.unit_price ? 'color:red;' : 'color:black'"
								@keydown.down.prevent="goTo('unit_price', index + 1)"
								@keydown.up.prevent="goTo('unit_price', index - 1)"
								@keydown.right.prevent="goTo('fob_price', index)"
								@keydown.left.prevent="goTo('quantity', index)"
								@input="priceInputEvent(index, item.class_code, item.cost, $event)"
							/>
						</td>
						<td v-if="user.company_id == 'jc'" class="al_right">{{ ((item.unit_price || 0) * (item.packing || 0)) | toPOCurrency(profile.po_decimal_point) }}</td>
						<td class="al_right">{{ item.amount | toPOCurrency(profile.po_decimal_point) }}</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model="item.fob_price"
								:precision="profile.po_decimal_point"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="fob_price"
								:style="item.im_fob != item.fob_price ? 'color:red;' : 'color:black'"
								@keydown.down.prevent="goTo('fob_price', index + 1)"
								@keydown.up.prevent="goTo('fob_price', index - 1)"
								@keydown.right.prevent="goTo('quantity', index + 1)"
								@keydown.left.prevent="goTo('unit_price', index)"
								@input="priceInputEvent2(index, item.class_code, item.cost, $event)"
							/>
						</td>
						<td class="al_right" v-if="user.company_id != 'jc'">{{ item.fob_amount | toPOCurrency(profile.po_decimal_point) }}</td>
						<td class="al_right">{{ item.packing | commaSeparated }}</td>
						<td v-if="user.company_id == 'jc'" class="al_right">{{ item.on_hand | commaSeparated }}</td>
						<td class="al_left"><CustomDatePicker v-model="item.esd" /></td>
						<td class="al_left"><CustomDatePicker v-model="item.eta_date" /></td>
						<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
						<td class="al_right">{{ item.remain_quantity | commaSeparatedZeroNull }}</td>
						<td class="al_right">{{ item.remain_amount | toPOCurrency(profile.po_decimal_point) }}</td>
						<td v-if="user.company_id == 'jc'" class="al_center"><a href="javascript:;" class="gray_bt2" @click="showItemHistory(item)">History</a></td>
					</tr>
					<tr>
						<td :colspan="totalColspan" class="al_right"><font color="red">Total</font></td>
						<td class="al_right" style="padding-right:8px;">
							<font color="red">{{ item_sum.total_quantity | commaSeparated }}</font>
						</td>
						<td v-if="user.company_id == 'jc'"></td>
						<td v-if="user.company_id == 'jc'"></td>
						<td v-if="user.company_id == 'jc'"></td>
						<td></td>
						<td v-if="user.company_id == 'jc'"></td>
						<td class="al_right">
							<font color="red"> {{ item_sum.total_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
						<td></td>
						<td class="al_right" v-if="user.company_id != 'jc'">
							<font color="red"> {{ item_sum.total_fob_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
						<td :colspan="user.company_id == 'jc' ? 4 : 3"></td>
						<td class="al_right">
							<font color="red">{{ item_sum.total_shipped_quantity | commaSeparated }}</font>
						</td>
						<td class="al_right">
							<font color="red" v-if="item_sum.total_remain_quantity != 0">{{ item_sum.total_remain_quantity | commaSeparated }}</font>
						</td>
						<td class="al_right">
							<font color="red" v-if="item_sum.total_remain_quantity != 0"> {{ item_sum.total_remain_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
						<td v-if="user.company_id == 'jc'"></td>
					</tr>
				</tbody>
			</table>

			<div class="tbl_bottom_bt">
				<input type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />

				<CustomDatePicker v-model="dateForCheck" />
				<input type="button" value="Apply ESD" class="int_line_bt" @click="applyEsdToItems(false)" />
				<input type="button" value="Apply ETA" class="int_line_bt" @click="applyEtaDateToItems(false)" />
			</div>

			<div class="view_bottom_bt">
				<a v-if="purchase.po_no" href="javascript:;" type="button" class="gray_bt fl_l mgr_5" @click="purchaseOrderPrint(false)">Print (Original)</a>
				<a v-if="purchase.po_no && item_sum.total_shipped_quantity > 0 && item_sum.total_quantity != item_sum.total_shipped_quantity" href="javascript:;" type="button" class="gray_bt fl_l" @click="purchaseOrderPrint(true)">
					Print (Remaining)
				</a>
				<a v-if="purchase.po_no" href="javascript:;" type="button" class="gray_bt fl_l mgl_15" @click="excelExport()">Excel</a>

				<a href="javascript:;" type="button" class="gray_bt fl_l mgl_15" @click="adjustCosts">Adjust Cost / FOB to Item Master's</a>

				<a v-if="modifiable && mode == 'detail' && !purchase.backorder_po_no && purchase.total_quantity > 0 && item_sum.total_remain_quantity > 0" href="javascript:;" type="button" class="gray_bt mgr_15" @click="backOrder()">Make Back Order</a>
				<a v-if="modifiable && mode == 'detail' && purchase.backorder_po_no" href="javascript:;" class="mgr_15" style="display:inline-block;padding-top:5px;" @click="openPO(purchase.backorder_po_no)">Back Order : {{ purchase.backorder_po_dn }}</a>
				<a v-if="modifiable && mode == 'detail' && purchase.original_po_no" href="javascript:;" class="mgr_15" style="display:inline-block;padding-top:5px;" @click="openPO(purchase.original_po_no)">Original Order: {{ purchase.original_po_dn }}</a>

				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>

				<a v-if="modifiable && mode == 'detail' && !purchase.shipment_exists" href="javascript:;" type="button" class="gray_bt mgl_15 mgr_15" @click="del()">Delete</a>

				<a v-if="mode === 'detail'" href="javascript:;" type="button" class="gray_bt mgl_15" @click="openModal('prevPurchaseShipment')">Prev. P/O & Ship</a>

				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Cancel</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<ItemPopup :initialItems="searchItems" :initialItemClass="itemClass" :initialKeyword="keyword" :vendor_code="purchase.vendor_code" operation="P" v-on:close="closeModal()" @set-items="addItems" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'prevPurchaseShipment'" :draggable="false" style="z-index:2000">
			<template slot="title">Prev. P/O & Ship</template>
			<template slot="body">
				<PrevPurchaseShipmentModal :po_no="purchase.po_no" @close="closeModal" />
			</template>
		</Modal>

		<ItemShipmentHistoryByVendorModal v-if="showModal && modalName == 'itemShipmentHistory'" :headers="headers" :item_id="history_item_id" :vendor_code="purchase.vendor_code" @close="closeModal" />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectPurchase, apiInsertPurchase, apiUpdatePurchase, apiDeletePurchase, apiCheckPurchaseExists, apiSelectPurchaseItemList } from '@/api/purchase/purchase.js';
import { apiLoadFromExcel, apiLoadFromExcelForPurchase } from '@/api/item/master.js';
import { apiGetReportTemplate, Report, companyMrtUrl, exportDataExcel } from '@/api/util';
import { today } from '@/utils/date.js';
import { defaultDataType } from 'export-xlsx';

import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PrevPurchaseShipmentModal from '@/views/purchase/PrevPurchaseShipmentModal.vue';
import ItemShipmentHistoryByVendorModal from '@/views/purchase/ItemShipmentHistoryByVendorModal.vue';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemPopup from '@/components/common/ItemPopup';
import Modal from '@/components/common/Modal';

import _ from 'lodash';
import XLSX from 'xlsx-js-style';
import 'floatthead';
import { generateDefaultCompanyPurchaseOrderPrint } from '@/utils/purchaseUtils';
import { escapeHtml, firstExcelRowNo, formatDuplicatedItemsMessage, formatExcelImportMessage, mergeExcelItems, parseExcelRowsForPurchase } from '@/utils/purchaseExcel.js';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/purchase/po_main',
			mode: 'add',
			purchase: {
				po_dn: null,
				discount_amount: null,
			},
			items: [],
			item_nos_to_delete: [],

			paymentTerms: [],
			tradeTerms: [],
			deliveryTypes: [],
			paymentTypes: [],
			locationTypes: [],
			holdTypes: [],
			users: [],

			remark: null,

			allSelected: false,

			itemClass: null,
			keyword: '',
			searchItems: [],

			modalName: '',
			showModal: false,
			history_item_id: null,

			dateForCheck: null,

			/** PO Excel 업로드 진행 중. 중복 요청과 재진입을 막는다. */
			excel_loading: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		item_sum: function() {
			var s = { total_quantity: 0, total_amount: 0, total_fob_amount: 0, total_shipped_quantity: 0, total_remain_quantity: 0, total_remain_amount: 0 };

			this.items.forEach(i => {
				if (i.quantity) s.total_quantity += i.quantity;
				if (i.amount) s.total_amount += i.amount;
				if (i.fob_amount) s.total_fob_amount += i.fob_amount;
				if (i.shipped_quantity) s.total_shipped_quantity += i.shipped_quantity;
				if (i.remain_quantity) s.total_remain_quantity += i.remain_quantity;
				if (i.remain_amount) s.total_remain_amount += i.remain_amount;
			});
			return s;
		},

		factory_code_show: function() {
			return this.user.company_id === 'he';
		},

		totalColspan: function() {
			let colspan = 4;
			if (this.profile.show_item_code === 'Y') colspan++;
			if (this.factory_code_show) colspan++;

			if (this.user.company_id == 'he') colspan++;

			if (this.user.company_id == 'jc') colspan--; // Color 컬럼 hidden

			return colspan;
		},
	},
	watch: {
		purchase: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	components: {
		PartnerSelect,
		CodeSelect,
		CustomDatePicker,
		ItemClassSelect,
		ItemPopup,
		Modal,
		PrevPurchaseShipmentModal,
		ItemShipmentHistoryByVendorModal,
	},
	methods: {
		readFile(event) {
			if (event.target.files.length == 0) return;
			const input = event.target;
			const file = input.files[0];
			// 같은 파일을 다시 고를 수 있게 비운다. change 는 값이 같으면 다시 발생하지 않는다.
			input.value = '';

			if (this.excel_loading) {
				this.$toast.error('Excel upload is already in progress.');
				return;
			}
			// 파일 읽기는 비동기라 여기서 미리 잠근다. load() 안에서 잠그면 파일을 연달아 고를 때
			// 두 요청이 동시에 나갈 수 있다.
			this.excel_loading = true;

			const reader = new FileReader();
			reader.onerror = () => {
				this.excel_loading = false;
				this.$toast.error('Failed to read the file.');
			};
			reader.onload = async e => {
				try {
					let data = e.target.result;
					data = new Uint8Array(data); // get excel file
					let excelFile = XLSX.read(data, { type: 'array', raw: true });
					let sheetName = excelFile.SheetNames[0];
					const sheet = excelFile.Sheets[sheetName];
					const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false });
					// 위쪽에 여백이 있는 파일은 배열 index 0 이 물리 1행이 아니다. 배열은 그대로 두고
					// 시작 행 번호만 넘겨 오류 안내의 행 번호를 사용자가 보는 번호와 맞춘다. #WK-20260821-05
					await this.load(rows, firstExcelRowNo(sheet, XLSX));
				} finally {
					this.excel_loading = false;
				}
			};
			reader.readAsArrayBuffer(file);
		},
		async load(rows, first_row_no) {
			// jc 는 Item Code / Barcode 로, 그 외 회사는 Style + Color 로 매칭한다.
			// 두 경로는 서버 계약이 서로 다르므로 화면에서도 갈라 둔다. #WK-20260821-05
			if (this.user.company_id == 'jc') await this.loadByItemCode(rows, first_row_no);
			else await this.loadByClassColor(rows, first_row_no);
		},
		/** jc: column A = Item Code or Barcode, column B = Quantity, row 1 = header. 공용 loadFromExcel 계약 그대로. */
		async loadByItemCode(rows, first_row_no) {
			var excel_items = [];
			var i;
			// 배열 index 는 그대로 두고(1행 = 머리글 규칙 유지) 물리 행 번호만 보정한다.
			const origin = first_row_no > 0 ? first_row_no : 1;
			for (i = 1; i < rows.length; i++) {
				if (rows[i][0]) {
					excel_items.push({
						excel_row_no: origin + i,
						excel_item_code: rows[i][0],
						excel_quantity: rows[i][1],
					});
				}
			}

			var param = {
				for_purchase: true,
				by_item_code: true,
				vendor_code: this.purchase.vendor_code,
				excel_json_str: JSON.stringify(excel_items),
			};

			const { data } = await apiLoadFromExcel(param);

			var all_found = data.excelItemList.filter(i => i.item_id);
			var not_found_items = data.excelItemList.filter(i => !i.item_id);
			// a code matching multiple items (dup barcode / code-barcode collision) is skipped and reported, to avoid silent over-ordering
			var ambiguous_items = all_found.filter(i => i.match_count > 1);
			var found_items = all_found.filter(i => !(i.match_count > 1));
			var valid_items = found_items.filter(i => i.active_yn == 'Y' && i.class_active_yn == 'Y' && i.class_closed_yn != 'Y' && !i.so_blocked);
			// complement so no matched row escapes reporting
			var invalid_items = found_items.filter(i => !valid_items.includes(i));

			var msg = '';
			msg = 'Excel items : ' + excel_items.length + '<br>';
			msg += 'Valid items : ' + valid_items.length + '<br>';
			msg += 'Invalid items : ' + invalid_items.length + '<br>';
			msg += 'Not found items : ' + not_found_items.length + '<br>';
			msg += 'Ambiguous items : ' + ambiguous_items.length + '<br>';
			not_found_items.forEach(i => {
				msg += '<br>Not found: excel row ' + i.excel_row_no + ', code = ' + i.excel_item_id;
			});
			ambiguous_items.forEach(i => {
				msg += '<br>Ambiguous code (matched ' + i.match_count + ' items, skipped): excel row ' + i.excel_row_no + ', code = ' + i.excel_item_id;
			});

			invalid_items.forEach(i => {
				msg += '<br>Invalid item: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				if (i.active_yn == 'N' || i.class_active_yn == 'N') msg += ', Inactive';
				if (i.class_closed_yn == 'Y') msg += ', Closed';
				if (i.so_blocked) msg += ', Blocked';
				if (!i.class_active_yn) msg += ', Class missing';
			});

			var to_add_items = [];
			valid_items.forEach(i => {
				i.quantity = i.excel_quantity;
				i.item_name = i.name;
				i.unit_price = i.net_price;
				i.amount = i.quantity * i.unit_price;
				i.fob_price = i.fob;
				i.fob_amount = i.quantity * i.fob_price;
				i.shipped_quantity = 0;
				to_add_items.push(_.cloneDeep(i));
			});

			this.mergeItems(to_add_items);

			this.$alertify.alert('Excel Import', msg);
		},
		/**
		 * Style + Color PO Excel 업로드. #WK-20260821-05
		 *
		 * 원본 행을 그대로 보내고 정규화·중복 제거·행별 상태 판정은 서버가 한다.
		 * 5,003행이어도 서버는 고유 Style+Color(사고 당시 47개)만 조회한다.
		 */
		async loadByClassColor(rows, first_row_no) {
			const excel_rows = parseExcelRowsForPurchase(rows, first_row_no);
			if (!excel_rows.length) {
				this.$toast.error('No data to import.');
				return;
			}

			const { data } = await apiLoadFromExcelForPurchase({
				vendor_code: this.purchase.vendor_code,
				rows: excel_rows,
			});

			if (!data.result) {
				this.$alertify.alert('Excel Import', escapeHtml(data.msg));
				return;
			}

			const load = data.load;
			const to_add_items = load.items.map(i => {
				const item = _.cloneDeep(i);
				item.quantity = item.excel_quantity;
				item.item_name = item.name;
				item.unit_price = item.net_price;
				item.amount = item.quantity * item.unit_price;
				item.fob_price = item.fob;
				item.fob_amount = item.quantity * item.fob_price;
				item.shipped_quantity = 0;
				return item;
			});

			this.mergeItems(to_add_items);

			this.$alertify.alert('Excel Import', formatExcelImportMessage(load));
		},
		async excelExport() {
			if (!this.purchase.po_no) return;

			const { data } = await apiSelectPurchaseItemList({ po_no: this.purchase.po_no });
			const purchaseItemList = data.purchaseItemList;
			if (!(purchaseItemList && purchaseItemList.length)) {
				this.$toast.error('No Data to Export.');
				return;
			}

			purchaseItemList.forEach(p => {
				if (!p.quantity) p.quantity = 0;
				if (!p.shipped_quantity) p.shipped_quantity = 0;
				if (!p.unit_price) p.unit_price = 0;
				p.remain_quantity = p.quantity - p.shipped_quantity;
				p.remain_amount = p.remain_quantity * p.unit_price;
			});

			const filename = 'PO_' + this.purchase.po_dn;

			const headers = [
				{ key: 'class_code', name: this.headers.class + ' Code', width: 20, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item Code', width: 30, dataType: defaultDataType.string },
				{ key: 'item_name', name: 'Item Name', width: 30, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'unit_price', name: 'Price', width: 15, dataType: defaultDataType.number },
				{ key: 'quantity', name: 'Order Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'amount', name: 'Order Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'fob_price', name: 'FOB Price', width: 15, dataType: defaultDataType.number },
				{ key: 'fob_amount', name: 'FOB Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'packing', name: 'Pack', width: 10, dataType: defaultDataType.currency },
				{ key: 'esd', name: 'ESD', width: 15, dataType: defaultDataType.string },
				{ key: 'eta_date', name: 'ETA', width: 15, dataType: defaultDataType.string },
				{ key: 'shipped_quantity', name: 'Shipped Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'remain_quantity', name: 'Remain Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'remain_amount', name: 'Remain Amt.', width: 15, dataType: defaultDataType.number },
			];
			exportDataExcel(purchaseItemList, headers, filename);
		},
		openPO(po_no) {
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: po_no } });
			window.open(routeData.href, 'herp_purchase');
		},
		backOrder() {
			this.mode = 'add';
			this.purchase.original_po_no = this.purchase.po_no;
			this.purchase.po_no = null;
			this.purchase.po_dn = null;
			this.purchase.po_type = 'B';
			this.purchase.po_date = today();
			this.purchase.estimated_ship_date = null;
			this.purchase.eta_date = null;

			var new_items = [];

			this.items.forEach(i => {
				if (i.quantity > i.shipped_quantity) {
					var new_item = _.cloneDeep(i);
					new_item.quantity = i.quantity - i.shipped_quantity;
					new_item.shipped_quantity = 0;
					new_item.esd = null;
					new_item.eta_date = null;

					new_items.push(new_item);
				}
			});

			this.items = new_items;
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate PO No');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckPurchaseExists(this.purchase);
			return data.result;
		},
		applyEsdToItems(all) {
			var toApplyItems;
			var toApplyDate;
			if (all) {
				toApplyItems = this.items;
				toApplyDate = this.purchase.estimated_ship_date;
			} else {
				toApplyItems = this.items.filter(i => i.selected);
				toApplyDate = this.dateForCheck;
			}

			toApplyItems.forEach(i => {
				i.esd = toApplyDate;
			});
		},
		applyEtaDateToItems(all) {
			var toApplyItems;
			var toApplyDate;
			if (all) {
				toApplyItems = this.items;
				toApplyDate = this.purchase.eta_date;
			} else {
				toApplyItems = this.items.filter(i => i.selected);
				toApplyDate = this.dateForCheck;
			}

			toApplyItems.forEach(i => {
				i.eta_date = toApplyDate;
			});
		},
		adjustCosts() {
			this.items.forEach(i => {
				i.unit_price = i.im_cost;
				i.fob_price = i.im_fob;
			});
		},

		async generateGroupedPurchaseOrderPrint(isRemaining) {
			if (isRemaining) {
				this.purchase.total_remain_quantity = this.item_sum.total_remain_quantity;
				this.purchase.total_remain_amount = this.item_sum.total_remain_amount;
			}

			const vm = this;
			const cbFunc = async include_price => {
				let item_groups = [];
				let separator = '  ';
				for (let item of vm.items) {
					let idx = item_groups.findIndex(g => g.class_name === item.class_name && g.unit_price === item.unit_price);
					let quantity = isRemaining ? item.remain_quantity : item.quantity;
					let amount = isRemaining ? item.remain_amount : item.amount;
					let qty_info_by_color = `${item.name === item.item_name ? item.color_code : item.item_name}-(${quantity})`;

					if (isRemaining && !quantity) continue;

					if (idx > -1) {
						item_groups[idx].quantity += quantity;
						item_groups[idx].amount += amount;
						item_groups[idx].qty_info_by_color += separator + qty_info_by_color;
					} else {
						item_groups.push({
							class_name: item.class_name,
							unit_price: item.unit_price,
							quantity,
							amount,
							qty_info_by_color,
						});
					}
				}

				let data = { isRemaining, include_price, purchase: vm.purchase, item_groups };
				let reportTemplate = await apiGetReportTemplate('PurchaseOrderDetail', companyMrtUrl('PurchaseOrderDetail'));
				const report = new Report(reportTemplate, data, 'PurchaseOrderDetail');
				vm.$store.commit('setReport', report);
			};

			this.$alertify.confirm(
				'Do You Want P/O Including Pricing Info',
				() => cbFunc(true),
				() => cbFunc(false),
			);
		},
		/**
		 * Print Purchase Order
		 * @param isRemaining
		 * @returns {Promise<*>}
		 */
		async purchaseOrderPrint(isRemaining) {
			let poNo = this.purchase.po_no;
			if (!poNo) return this.$toast.error('No Data To Be Shown');

			await generateDefaultCompanyPurchaseOrderPrint(poNo, isRemaining, this.user);
		},
		async del() {
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeletePurchase(this.purchase);
				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.$router.push(this.backUri);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		priceInputEvent(index, class_code, cost, price) {
			for (var i = index + 1; i < this.items.length; i++) {
				if (this.items[i].class_code == class_code) {
					this.items[i].unit_price = price + this.items[i].cost - cost;
				}
			}
		},
		priceInputEvent2(index, class_code, cost, fob_price) {
			for (var i = index + 1; i < this.items.length; i++) {
				if (this.items[i].class_code == class_code) {
					this.items[i].fob_price = fob_price + this.items[i].cost - cost;
				}
			}
		},
		goTo(colType, index) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					if (colType == 'unit_price') this.$refs.unit_price[index].$el.select();
					else if (colType == 'quantity') this.$refs.quantity[index].$el.select();
					else if (colType == 'fob_price') this.$refs.fob_price[index].$el.select();
				}
			});
		},
		selectClasses(input) {
			return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			this.itemClass = c.selectedObject.code;
			this.search();
		},
		searchKeyword(keyword) {
			this.$refs.ac.clear();
			this.keyword = keyword;
			this.search();
		},
		selectItem(item) {
			let routeData = this.$router.resolve({ name: 'itemMaster', params: {}, query: { backUri: this.$route.fullPath, keyword: item.item_id } });
			window.open(routeData.href, '_blank');
		},
		setItemClass() {
			this.search();
		},
		async search() {
			if (!this.purchase.vendor_code) {
				this.$toast.error('Select Vendor first.');
				return;
			}
			this.openModal('ItemSelect');
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
		},
		deleteItems() {
			const wrong_selected_list = this.items.filter(it => it.selected && it.shipment_exists);
			if (wrong_selected_list.length > 0) {
				const msg = `Shipping History for ${wrong_selected_list.map(el => el.item_code).join(', ')} in the P/O Already Exists.`;
				this.$alertify.alert('Alert', msg);
				return;
			}

			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].selected) {
					if (this.items[i].po_item_no) this.item_nos_to_delete.push(this.items[i].po_item_no);
					this.items.splice(i, 1);
				}
			}
		},
		copyItems() {
			if (this.items.length > 200) {
				this.$toast.error('Too many items');
				return;
			}

			if (this.items.length > 0) {
				this.$session.set('items', this.items);
				this.$toast.success('All item is copied');
			}
		},
		pasteItems() {
			//console.log(this.$session.get('items'));
			//var copiedItems = this.$session.get('items');
		},
		selectAll() {
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		calTotal() {
			var total_amount = 0;
			var total_quantity = 0;
			var is_jc = this.user.company_id == 'jc';

			this.items.forEach(function(item) {
				// JC: PO Qty 1 = 1 CS, Amount = Qty × Price × Qty per carton (item.packing)
				var qpc = is_jc && item.packing > 0 ? item.packing : 1;
				item.amount = item.quantity * item.unit_price * qpc;
				item.fob_amount = item.quantity * item.fob_price * qpc;

				item.remain_quantity = item.quantity - item.shipped_quantity;
				item.remain_amount = item.remain_quantity * item.unit_price * qpc;

				total_quantity += item.quantity;
				total_amount += item.amount;
			});
			this.purchase.total_quantity = total_quantity;
			this.purchase.total_amount = total_amount - this.purchase.discount_amount;
			this.purchase.item_amount = total_amount;
		},
		setVendor(partner) {
			this.purchase.vendor_name = partner.name;
		},
		async selectPurchase() {
			const { data } = await apiSelectPurchase({
				po_no: this.purchase.po_no,
			});

			this.purchase = data.purchase;
			this.items = data.purchaseItemList;
			this.items
				.filter(i => i.quantity == 0)
				.forEach(i => {
					i.selected = true;
				});
		},
		checkValidity() {
			if (!this.purchase.po_date) {
				this.$toast.error('Empty PO Date');
				return false;
			}

			if (!this.purchase.vendor_code) {
				this.$toast.error('Empty Vendor');
				return false;
			}
			return true;
		},
		async save(stay) {
			if (await this.checkValidity()) {
				await this.submit(stay);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		async submit(stay) {
			this.purchase.items = this.items;
			this.purchase.item_nos_to_delete = this.item_nos_to_delete;

			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate PO No');
					return;
				}
				response = await apiInsertPurchase(this.purchase);
			} else {
				response = await apiUpdatePurchase(this.purchase);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');

				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.purchase.po_no = data.po_no;
						this.purchase.po_dn = data.po_dn;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Purchase Order -> Detail');
					}
					await this.selectPurchase();
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			if (this.modalName == 'ItemSelect') {
				this.keyword = '';
				this.itemClass = null;
			}

			this.showModal = false;
		},
		showItemHistory(item) {
			this.history_item_id = item.item_id;
			this.openModal('itemShipmentHistory');
		},
		addItems(items) {
			var vm = this;
			items.forEach(function(item) {
				item.item_name = item.name;
				item.im_cost = item.cost;
				item.im_fob = item.fob;

				item.unit_price = item.net_price;
				if (item.fob) item.fob_price = item.fob;
				else item.fob_price = null;

				vm.items.push(item);
			});
			inputSelectOnClick();
			this.reset();
		},
		/**
		 * 업로드 품목을 기존 PO 품목에 합친다. 기존 구현은 새 품목마다 기존 배열 전체를
		 * filter 해서 수천 행에서 화면이 멈췄다. 이제 item_id 색인 한 번으로 O(n) 이다. #WK-20260821-05
		 */
		mergeItems(items) {
			const merged = mergeExcelItems(this.items, items);
			this.items = merged.items;

			if (merged.duplicated_labels.length > 0) {
				window.alert(formatDuplicatedItemsMessage(merged.duplicated_labels));
			}

			this.$forceUpdate();
		},
		async index() {
			const { data } = await apiIndex();

			this.paymentTerms = data.paymentTermList;
			this.tradeTerms = data.tradeTermList;
			this.deliveryTypes = data.poDeliveryTypeList;
			this.paymentTypes = data.paymentTypeList;
			this.holdTypes = data.poHoldTypeList;
			this.locationTypes = data.locationList;

			this.users = data.userList;
		},
		async init() {
			await this.index();

			if (this.mode == 'detail') {
				await this.selectPurchase();
			}
			inputSelectOnClick();
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_po_main');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Purchase Order -> Add');
			this.purchase.po_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Purchase Order -> Detail');
			this.purchase.po_no = this.$route.query.po_no;
			if (!this.purchase.po_no) {
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
	},
	mounted() {
		$(this.$refs.purchase_items).floatThead({ zIndex: 1, autoReflow: true });

		this.$nextTick(function() {
			if (this.mode == 'add') {
				if (this.user.company_id == 'newjigu') this.purchase.payment_term_code = 'TT';
				else this.purchase.payment_term_code = 'LC';

				this.purchase.trade_term_code = 'FOB';
				this.purchase.po_delivery_type_code = 'S';
				this.purchase.payment_type_code = 'NP';

				this.purchase.po_type = 'N';
			}
			inputSelectOnClick();
		});
	},
};
</script>

<style></style>
